module.exports = __webpack_public_path__ + "img/26.f74e6601.png";